// PromoCodeType
export const PromoCodeType = {
  GENERAL: 0,
  PERSONAL: 1,
  GIFT: 2,
} as const;

export type PromoCodeType = typeof PromoCodeType[keyof typeof PromoCodeType];

export const PromoCodeTypes = {
  [PromoCodeType.GENERAL]: {
    value: PromoCodeType.GENERAL,
    name: 'Общий',
  },
  [PromoCodeType.PERSONAL]: {
    value: PromoCodeType.PERSONAL,
    name: 'Личный',
  },
  [PromoCodeType.GIFT]: {
    value: PromoCodeType.GIFT,
    name: 'Подарочный',
  },
} satisfies Record<PromoCodeType, { value: PromoCodeType; name: string }>;

export const getPromoCodeTypeFlags = (type: PromoCodeType) => ({
  isGeneral: type === PromoCodeType.GENERAL,
  isPersonal: type === PromoCodeType.PERSONAL,
  isGift: type === PromoCodeType.GIFT,
});

// PromoCodeConditionType
export const PromoCodeConditionType = {
  MIN_PRICE: 0,
  ITEMS: 1,
  ACCUMULATIVE: 2,
} as const;

export type PromoCodeConditionType =
  typeof PromoCodeConditionType[keyof typeof PromoCodeConditionType];

export const PromoCodeConditionTypes = {
  [PromoCodeConditionType.MIN_PRICE]: {
    value: PromoCodeConditionType.MIN_PRICE,
    name: 'Минимальная цена',
  },
  [PromoCodeConditionType.ITEMS]: {
    value: PromoCodeConditionType.ITEMS,
    name: 'Товары в корзине',
  },
  [PromoCodeConditionType.ACCUMULATIVE]: {
    value: PromoCodeConditionType.ACCUMULATIVE,
    name: 'За количество',
  },
} satisfies Record<
  PromoCodeConditionType,
  {
    value: PromoCodeConditionType;
    name: string;
  }
>;
